// @flow
import * as React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { useState} from "react";
import CustomModal from "../CustomModal";
import {useDispatch, useSelector} from "react-redux";
import {Link} from "react-router-dom";

export const Footer = () => {
    const [mobileNumber, setMobileNumber] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [loginError, setLoginError] = useState('');
    const [token, setToken] = useState('');

    const dispatch = useDispatch();
    const [credentials, setCredentials] = useState({ username: '', password: '' });
    const authState = useSelector((state) => state.auth);

    const handleLogout = () => {
        // Perform logout logic here, e.g., clear the token from state
        document.cookie = 'userId=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
        setIsLoggedIn(false);
        setToken('');
    };

    const fetchDataWithToken = async () => {
        try {
            const response = await fetch('http://localhost:5000/api/secure-data', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.ok) {
                const secureData = await response.json();
            } else {
                console.error('Error fetching secure data:', response.statusText);
            }
        } catch (error) {
            console.error('Error fetching secure data:', error);
        }
    };


    const [isModalOpen, setIsModalOpen] = useState(false);


    const closeModal = () => {
        setIsModalOpen(false);
    };
    return (<>
       
            <CustomModal isOpen={isModalOpen} closeModal={closeModal}  />
            <div>

                <div dir="rtl" className="bottom-menu m-auto mt-5">
                    {!authState?.isLoggedIn ? <span id="loginFooter" data-bs-toggle="modal" data-bs-target="#ModalLogin"
                                          className="hovermenu nav-link  d-flex flex-column gap-1" onClick={() => setIsModalOpen(true)}>
            <FontAwesomeIcon icon="user"/>
                ورود
            </span> : <span id="myaccfooter">
                <Link to={`/profile`} className="hovermenu  d-flex flex-column gap-2">
                      <FontAwesomeIcon icon="user"/>
                    پروفایل
                </Link>
            </span>}
                    <Link dir="ltr" className="paddin-call hovermenu d-flex flex-column gap-2" id="SOrder" to="/shops">
                        <FontAwesomeIcon icon="shopping-bag"/>
                        فروشگاه ها
                    </Link>
                    <Link id="homebutton" to="/" className="sat hovermenu  d-flex flex-column gap-2">
                        <FontAwesomeIcon icon="home"/>
                    </Link>
                    <Link id="Tracking" className="padding-chat hovermenu  d-flex flex-column gap-2" to="/tutorial">
                        <FontAwesomeIcon icon="book"/>
                        آموزش
                    </Link>
                    <Link id="Invoice" to="/support" className="hovermenu  d-flex flex-column gap-2">
                        <FontAwesomeIcon icon="headset"/>
                        پشتیبانی
                    </Link>
                </div>

            </div>
        </>);
};
